import React, { useMemo } from 'react';

import { getWorkflowConstants } from '~/common/constants/workflow';
import { WorkflowFieldType } from '~/enums/WorkflowFieldType';
import { useIntl } from 'react-intl';
import { sortByStringValue } from '~/utils/array';

import RadioItem from './RadioItem';

function RadioFieldTypes({ selectedFieldDefinition, onClick }) {
  const intl = useIntl();
  const { fieldTypeLabels } = getWorkflowConstants(intl);

  const fieldTypeOptions = useMemo(
    () =>
      Object.values(WorkflowFieldType)
        .map((fieldType) => ({
          label: fieldTypeLabels[fieldType],
          value: fieldType,
        }))
        .filter(
          (option) =>
            ![
              WorkflowFieldType.Boolean,
              WorkflowFieldType.DateSigned,
              WorkflowFieldType.Signature,
              WorkflowFieldType.ConditionalText,
              WorkflowFieldType.Initials,
              WorkflowFieldType.Reference,
            ].includes(option.value),
        )
        .sort(sortByStringValue('label')),
    [],
  );

  return (
    <>
      {fieldTypeOptions.map((option) => (
        <RadioItem
          key={option.value}
          option={option}
          selected={selectedFieldDefinition?.fieldType === option.value}
          onClick={() => onClick(option.value)}
        />
      ))}
    </>
  );
}

export default RadioFieldTypes;
